import { createExternalPermissionSocket } from "./use-permission-websocket";
import { callLcosService } from "../../data/lcosServices";
import { StaffMemberPermissions } from "../use-staff";
import { QueryClient } from "@tanstack/react-query";

export function useExternalPermissionFlow() {
  const handleExternalPermissionFlow = async (
    accessToken: string,
    payload: { action: string; isAllowed: boolean },
    centerId: string,
    staffMemberId: string,
    queryClient: QueryClient,
    queryKey: readonly unknown[]
  ) => {
    const socket = createExternalPermissionSocket(centerId, staffMemberId);

    try {
      await socket.ready;
      await triggerExternalPermission(accessToken, payload, centerId, staffMemberId);
      await socket.completed;
      await queryClient.invalidateQueries({ queryKey });
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "External permission flow failed";
      window.toasts.add({
        content: errorMessage,
        type: "danger"
      });
      console.error("External permission error:", err);
    } finally {
      socket.close();
    }
  };

  return { handleExternalPermissionFlow };
}

const triggerExternalPermission = async (
  accessToken: string,
  variables: { action: string; isAllowed: boolean },
  centerId: string,
  staffMemberId: string
) => {
  await callLcosService<StaffMemberPermissions>(
    accessToken,
    `/api/staff/${centerId}/${staffMemberId}/external_permission`,
    "PUT",
    {
      permission: variables.action,
      is_allowed: variables.isAllowed
    }
  );
};
